import { Injectable } from 'angular-ts-decorators';

/**
 * Service for interacting with the service worker
 */
@Injectable('swServiceWorker')
// TODO move to sw-service-worker OR rename to service-worker
export class SwServiceWorker {
  constructor(
    private $log: ng.ILogService,
    private $window: ng.IWindowService,
    private sentry,
    private moment,
  ) {
    'ngInject';
  }

  startWorking(): void {
    if ('serviceWorker' in navigator) {
      this.$window.navigator.serviceWorker
        .getRegistrations()
        .then((registrations) => {
          for (let registration of registrations) {
            registration.unregister();
          }
        });
    }
  }
}
